import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlMessagingLayoutProps } from './messaging.props';

import * as TagNames from './messaging.tagnames';

@customElement(TagNames.MessagingLayout)
export class AtlMessagingLayout
   extends LitElement
   implements AtlMessagingLayoutProps
{
   declare fullHeight?: boolean;
   declare contactsColClassName?: string;
   declare chatPanelColClassName?: string;

   static properties = {
      fullHeight: { attribute: 'full-height', type: Boolean },
      contactsColClassName: {
         attribute: 'contacts-col-classname',
         type: String,
      },
      chatpanelColClassName: {
         attribute: 'chatpanel-col-classname',
         type: String,
      },
   };

   constructor() {
      super();
   }

   static styles = [...getGlobalStyleSheets()];

   render() {
      const classNames = [
         'row',
         'messaging-layout',
         this.className,
         this.fullHeight ? 'full-height' : '',
      ];
      const contactsClassNames = [
         'col-md-4',
         'contacts-col',
         this.contactsColClassName,
      ];
      const chatPanelClassNames = [
         'col-md-8',
         'chat-panel-col',
         this.chatPanelColClassName,
      ];

      return html`
         <div class=${classNames.join(' ')}>
            <div class=${contactsClassNames.join(' ')}>
               <slot name="slotContactsCol"></slot>
            </div>
            <div class=${chatPanelClassNames.join(' ')}>
               <slot name="slotChatPanelCol"></slot>
            </div>
         </div>
      `;
   }
}
